import { Point } from "@nova/data-create-polygon-kml"
import { Line } from "@nova/protobuf"

export enum DownloadType {
    iconKml = "icon-kml",
    iconShp = "icon-shp",

    lineKml = "line-kml",
    lineShp = "line-shp",

    rulerKml = "ruler-kml",
    rulerShp = "ruler-shp",

    hotspotHeatPointKml = "hotspot-heat-point-kml",
    hotspotHeatPointCsv = "hotspot-heat-point-csv",
    hotspotHeatPointShp = "hotspot-heat-point-shp",

    hotspotHeatPolyKml = "hotspot-heat-poly-kml",
    hotspotHeatPolyShp = "hotspot-heat-poly-shp",

    hotspotHeatOrthoTiff = "hotspot-heat-ortho-tiff",
    hotspotHeatOrthoJpg = "hotspot-heat-ortho-jpg",
    hotspotHeatOrthoPng = "hotspot-heat-ortho-png",
    hotspotHeatOrthoKmz = "hotspot-heat-ortho-kmz",

    hotspotPathKml = "hotspot-path-kml",
    hotspotPathShp = "hotspot-path-shp",

    hotspotImagesZip = "hotspot-images-zip",

    firePerimeterKml = "fp-kml",

    orthoOrthoTiff = "ortho-ortho-tiff",
    orthoOrthoJpg = "ortho-ortho-jpg",
    orthoOrthoPng = "ortho-ortho-png",
    orthoOrthoKmz = "ortho-ortho-kmz",

    orthoDemTiff = "ortho-dem-tiff",

    orthoPathKml = "ortho-path-kml",
    orthoPathShp = "ortho-path-shp",

    videoMp4 = "video-mp4",
    videoSrt = "video-srt",

    colorFinderMp4 = "vcf-mp4",
    colorFinderSrt = "vcf-srt",
    colorFinderJpg = "icf-zip",
}

export type DownloadOption = {
    name: string
    type: DownloadType
    selected?: boolean
}

export type Category = {
    name: string
    collapsed?: boolean
    categories?: Category[]
    downloadOptions?: DownloadOption[]
}

export type ParsedGeoLayers = {
    lines: ParsedGeoLayer
    polygons: ParsedGeoLayer
}

export type ParsedGeoLayer = {
    kml: Line[]
    shp: { name: string; points: Point[] }[]
}
